export default {
  canvas: {
    width: 5665,
    height: 2491,
  },
  zoom: {
    in: 3.5,
    out: 1,
    outMagicNumber: -1996,
  },
  animation: {
    steps: 25,
    interval: 25, // Miliseconds
  },
};
